(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!window.__wpDeferredVideoObserverInit) {
  window.__wpDeferredVideoObserverInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('.section-multicolumn-grid__video video');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.play().catch(function () {});
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function (v) {
      var wrapper = v.closest('.video-player');
      if (wrapper) {
        v.addEventListener('play', function () { wrapper.classList.add('playing'); });
        v.addEventListener('pause', function () { wrapper.classList.remove('playing'); });
      }
      observer.observe(v);
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
